import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppCalendar } from "./AppCalendar";
import "./AppCalendarPage.css";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { CalendarItem } from "./AppCalendar";


type AppCalendarPageProps = {
}

export const AppCalendarPage = ({} : AppCalendarPageProps) => {

    const storeUser = useSelector(selectUser);
    const dispatch = useDispatch();
    const uiStates = useSelector(selectUIStates);
    const [calendarItems, setCalendarItems] = useState<CalendarItem[]>([]);

    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Company Calendar"}));
    }, []);

    useEffect(() => {
        if (!storeUser) {
            return;
        }

    }, [storeUser]);
        
    return (
         <div className="app-calendar-page">
            <AppCalendar
                items={calendarItems}
                onItemClick={(item) => {
                    console.log("Item clicked:", item);
                }}
            />

         </div>
    )
}